import { useCallback, useState } from 'react';
import type { DataTableMode } from '@odo/shared-ui';
import { readTableMode, writeTableMode } from '../utils/tableModePreference';

// Remembered for the browser session only, like useDataTable's storageKey.
export function useSessionTableMode(
    storageKey: string
): [DataTableMode, (mode: DataTableMode) => void] {
    const [mode, setModeState] = useState<DataTableMode>(() =>
        readTableMode(globalThis.sessionStorage, storageKey)
    );
    const setMode = useCallback(
        (next: DataTableMode) => {
            setModeState(next);
            writeTableMode(globalThis.sessionStorage, storageKey, next);
        },
        [storageKey]
    );
    return [mode, setMode];
}
